<template>
    <div>
        <!-- Header -->
        <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
            <b-container class="container">
                <div class="header-body text-center mb-7">
                    <b-row class="justify-content-center">
                        <b-col xl="5" lg="6" md="8" class="px-5">
                            <h1 class="text-white">
                                Tell us a bit about yourself
                            </h1>
                            <p class="text-lead text-white">
                                We would love to get to know you
                            </p>
                        </b-col>
                    </b-row>
                </div>
            </b-container>
            <!-- <div class="separator separator-bottom separator-skew zindex-100">
                <svg
                    x="0"
                    y="0"
                    viewBox="0 0 2560 100"
                    preserveAspectRatio="none"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <polygon
                        class="fill-default"
                        points="2560 0 2560 100 0 100"
                    ></polygon>
                </svg>
            </div> -->
        </div>
        <!-- Page content -->
        <b-container class="mt--9 pb-5">
            <!-- Table -->
            <b-row class="justify-content-center">
                <b-col lg="6" md="8">
                    <b-card no-body class="bg-secondary border-0">
                        <div class="row justify-content-center">
                            <div class="col-6 mt-5">
                                <img
                                    src="img/brand/logos/otinga.svg"
                                    class="img-fluid"
                                />
                            </div>
                        </div>
                        <!--  <b-card-header class="bg-transparent pb-5">
                            <div class="text-muted text-center mt-2 mb-4">
                                <small>Register with</small>
                            </div>
                            <div class="text-center">
                                <a href="#" class="btn btn-neutral btn-icon">
                                    <span class="btn-inner--icon"
                                        ><img src="img/icons/common/google.svg"
                                    /></span>
                                    <span class="btn-inner--text">Google</span>
                                </a>
                                <a href="#" class="btn btn-neutral btn-icon">
                                    <span class="btn-inner--icon"
                                        ><img src="img/icons/common/apple.svg"
                                    /></span>
                                    <span class="btn-inner--text">Apple</span>
                                </a>
                            </div>
                        </b-card-header> -->
                        <b-card-body class="px-lg-5 py-lg-5">
                            <!-- <div class="text-center text-muted mb-4">
                                <small>Or register with credentials</small>
                            </div> -->

                            <validation-observer
                                v-slot="{ handleSubmit }"
                                ref="formValidator"
                            >
                                <b-form
                                    role="form"
                                    @submit.prevent="handleSubmit(onSubmit)"
                                >
                                    <base-input
                                        label="Have you ever hosted a hackathon before? "
                                        :rules="{ required: true }"
                                        :pill="true"
                                        name="above"
                                        :disabled="$apollo.loading"
                                        placeholder="Select one"
                                    >
                                        <el-select
                                            class="form"
                                            v-model="
                                                form.hosted_hackathon_before
                                                    .value
                                            "
                                            :filterable="true"
                                        >
                                            <el-option
                                                v-for="option in form
                                                    .hosted_hackathon_before
                                                    .options"
                                                :key="option.name"
                                                :label="option.name"
                                                :value="option.name"
                                            >
                                            </el-option>
                                        </el-select>
                                    </base-input>

                                    <base-input
                                        label="What is your main reason for signing up? "
                                        :pill="true"
                                        name="above"
                                        :disabled="$apollo.loading"
                                    >
                                        <el-select
                                            class="form"
                                            v-model="form.reason_for_use.value"
                                            :filterable="true"
                                            multiple
                                            placeholder="Select all that applies"
                                        >
                                            <el-option
                                                v-for="option in form
                                                    .reason_for_use.options"
                                                :key="option.name"
                                                :label="option.name"
                                                :value="option.name"
                                            >
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                    <base-input
                                        label="How did you hear about us? "
                                        :rules="{ required: true }"
                                        :pill="true"
                                        name="Referral"
                                        :disabled="$apollo.loading"
                                        placeholder="Select one"
                                    >
                                        <el-select
                                            class="form"
                                            v-model="form.referral.value"
                                            :filterable="true"
                                        >
                                            <el-option
                                                v-for="option in form.referral
                                                    .options"
                                                :key="option.name"
                                                :label="option.name"
                                                :value="option.name"
                                            >
                                            </el-option>
                                        </el-select>
                                    </base-input>

                                    <base-input
                                        class="mb-3"
                                        label="What is your main challenge with innovation?"
                                        name="above"
                                        placeholder="e.g. It's difficult to start"
                                        v-model="form.main_challenge"
                                    >
                                    </base-input>

                                    <div class="text-center">
                                        <div
                                            v-for="error_message in error_messages"
                                            :key="error_message"
                                        >
                                            <div
                                                class="invalid-feedback"
                                                style="display: block"
                                            >
                                                {{ error_message }}
                                            </div>
                                        </div>

                                        <base-button
                                            type="primary"
                                            :pill="true"
                                            native-type="submit"
                                            class="my-4"
                                            :loading="is_loading"
                                            :disabled="is_loading"
                                            :success="success"
                                            >Continue
                                            <i class="fas fa-arrow-right"></i
                                        ></base-button>
                                    </div>
                                </b-form>
                            </validation-observer>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import { Select, Option } from "element-ui";
import { BATCH_CREATE_USER_PROFILE_META_DATA } from "@/graphql/mutations";

export default {
    name: "register",
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
        return {
            form: {
                reason_for_use: {
                    value: null,
                    options: [
                        { name: "Host Internal Hackahtons" },
                        { name: "Host Public Hackahtons" },
                        { name: "Promote Internal Innovation" },
                        { name: "Host Co-innovation Hackathons" },
                        { name: "Use Hackathons within SAFe" },
                    ],
                },
                hosted_hackathon_before: {
                    value: null,
                    options: [{ name: "Yes" }, { name: "No" }],
                },
                referral: {
                    value: null,
                    options: [
                        { name: "Search engine (e.g. Google, Bing)" },
                        {
                            name: "Social media (e.g. Twitter, LinkedIn)",
                        },
                        { name: "Referral from a friend or colleague" },
                        { name: "Online advertisement" },
                        {
                            name: "Webinar",
                        },
                        { name: "Event or conference" },
                        { name: "Blog or online article" },
                        { name: "Podcast" },
                        { name: "Email newsletter" },
                        { name: "Direct e-mail" },
                        { name: "Other" },
                        { name: "Prefer not to say" },
                    ],
                },
                main_challenge: null,
            },
            is_loading: false,
            success: false,
            error_messages: [],
            next: null,
        };
    },
    methods: {
        onSubmit() {
            this.is_loading = true;
            this.$apollo
                .mutate({
                    mutation: BATCH_CREATE_USER_PROFILE_META_DATA,
                    variables: {
                        meta_data_objects: [
                            {
                                metaDataType: "referral_source",
                                value: JSON.stringify({
                                    value: this.form.referral.value,
                                }),
                            },
                            {
                                metaDataType: "reason_for_using_product",
                                value: JSON.stringify({
                                    value: this.form.reason_for_use.value,
                                }),
                            },
                            {
                                metaDataType: "hosted_hackathon_before",
                                value: JSON.stringify({
                                    value: this.form.hosted_hackathon_before
                                        .value,
                                }),
                            },
                            {
                                metaDataType: "main_innovation_challenge",
                                value: JSON.stringify({
                                    value: this.form.main_challenge,
                                }),
                            },
                        ],
                    },
                })
                .then((res) => {
                    this.success = true;
                    setTimeout(() => {
                        this.route_to_path("/welcome/company");
                        this.success = false;
                        this.is_loading = false;
                    }, 500);
                })
                .catch((res) => {
                    this.is_loading = false;
                    this.route_to_path("/welcome/company");
                });

            this.error_messages = [];
        },
        route_to_path(path) {
            this.$router.push({ path: path, query: this.$route.query });
        },
        get_next() {
            if (this.$route.query.next) {
                this.next = this.$route.query.next;
            }
        },
    },
    mounted() {
        this.get_next();
    },
    watch: {
        $route: {
            immediate: true,
            handler: function () {
                this.get_next();
            },
        },
    },
};
</script>
<style>
.el-input__inner {
    border-radius: 2rem;
}
</style>
